package one.healthium.life

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://life-content-stage.web.app/"
                Flavour.Prod -> "https://life-content-prod.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = "",
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "LIFE",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> ""
            Flavour.Prod -> ""
        },
        adaptyKey = "public_live_EH13dTc9.W5oBFiULQ77jba2r5N4i",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6748703364",
        feedbackEmail = "life@healthium.one",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:614757064021:android:1325844e625bbc7f3ba3dc",
                apiKey = "AIzaSyAr0KvohNT_goB0gCAJ2Qlrjom6A4n3AyA",
                projectId = "healthy-life-app-stage",
                storageBucket = "healthy-life-app-stage.firebasestorage.app",
                userStorageBucket = "gs://healthy-life-app-stage-users-data",
                authDomain = "healthy-life-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:957653837032:android:055db809d1ad8aa87dd55d",
                apiKey = "AIzaSyCnZyT0RLLCi3rSqenEG5oDH29OCPN5cyM",
                projectId = "healthy-life-app-prod",
                storageBucket = "healthy-life-app-prod.firebasestorage.app",
                userStorageBucket = "gs://healthy-life-app-prod-users-data",
                authDomain = "healthy-life-app-prod.firebaseapp.com",
            )
        },
        appId = when (flavour) {
            Flavour.Stage -> "life_stage"
            Flavour.Prod -> "life"
        },
        oneLinkBaseUrl = "https://hltm-life.onelink.me/9CMN/web",
    )

